'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function getCellAlignment(field_type) {
  switch (field_type) {
    case 'number':
    case 'datetime':
    case 'date':
    case 'currency':
      {
        return 'right';
      }

    case 'checkbox':
    case 'bool':
      {
        return 'center';
      }

    default:
      {
        return 'left';
      }
  }
}

exports.default = getCellAlignment;
exports.getCellAlignment = getCellAlignment;
